import {CastingTimeUnit} from '../../generated/types';
import {wordByCount} from '../utils';

export function castingTimeUnitToString(value: number, unit: CastingTimeUnit) {
	let words = [];
	let showUnit = false;

	switch (unit) {
		case CastingTimeUnit.Minute:
			words = ['минута', 'минуты', 'минут'];
			showUnit = true;
			break;
		case CastingTimeUnit.Hour:
			words = ['час', 'часа', 'часов'];
			showUnit = true;
			break;
		case CastingTimeUnit.Action:
			words = ['Действие', 'Действия', 'Действий'];
			break;
		case CastingTimeUnit.Bonus:
			words = ['Бонусное действие', 'Бонусных действия', 'Бонусных действий'];
			break;
		case CastingTimeUnit.Reaction:
			words = ['Ответное действие', 'Ответных действия', 'Ответных действий'];
	}
	return wordByCount(value, words, showUnit || value > 1);
}
